import React from 'react';
import { LOGO_GREEN } from '../../constants/config';

const LogoIconGreen = () => (
  <img
    alt="logo"
    src={LOGO_GREEN}
    style={{ height: '100%', objectFit: 'contain' }}
  />
);

export { LogoIconGreen };
